/**
 * @param {string} path
 * @returns {boolean}
 */
export default function isLocal(path) {
  return /^(https?:)?\/\/localhost($|[/:])/.test(path)
}



// WEBPACK FOOTER //
// ./node_modules/santa-main-r/src/lib/common/isLocal.js